var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.groups)?_c('div',_vm._l((_vm.groups),function(lv){return _c('div',{key:lv.key},[_c('Level',{attrs:{"level":lv},on:{"click":_vm.s2Click}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }